export const formOptions = {
  // Opciones para Cauciones
  operacion: ['Colocadora', 'Tomadora'],
  moneda: ['Pesos', 'USD Mep', 'USD Cable'],
  mercado: ['BYMA', 'A3', 'MAV'],
  estado: ['Pendiente', 'En Proceso', 'Hecha', 'Rechazada'],

  // --- CAMBIO: Se añaden nuevas opciones para Operaciones Generales ---
  operacionGeneral: ['Compra', 'Venta'],
  plazo: ['C.I.', '24hs'],
  monedaGeneral: ['Pesos', 'USD Mep', 'USD Cable'],
  mercadoGeneral: ['BYMA', 'MAV', 'A3', 'SENEBI', 'EXTERIOR', 'JEFFERIES'],
  estadoGeneral: ['Pendiente', 'En Proceso', 'Hecha', 'Rechazada'],

  // Instrucciones operativas (Middle Office)
  tipoInstruccion: [
    'Ingreso',
    'Egreso',
    'Suscripcion FCI',
    'Rescate FCI',
    'Transferencia Titulos Salida',
    'Transferencia Titulos Entrada',
  ],
  monedaInstruccion: ['Pesos', 'USD Mep', 'USD Cable'],
  estadoInstruccion: ['Pendiente', 'En Proceso', 'Hecha', 'Rechazada'],
  plazoLiquidacionFci: ['T+0', 'T+1'],
  // Vía de un Egreso. "MEP GC2" es la transferencia por MEP con el código de
  // rescate de FCI, exento del impuesto a los débitos y créditos bancarios.
  viaEgreso: ['Transferencia normal', 'MEP GC2'],

  // Licitaciones primarias
  tramoLicitacion: ['Competitivo', 'No Competitivo'],
  modalidadLicitacion: ['Tasa', 'Precio'],
  estadoLicitacion: ['Abierta', 'Cerrada', 'Adjudicada', 'Liquidada'],
  monedaEmisionLicitacion: ['Pesos', 'USD'],
  monedaIntegracionLicitacion: ['Pesos', 'USD Mep', 'USD Cable'],
  // Valores que acepta la columna `tipoDocumento` del Excel de carga al sistema.
  tipoDocumentoCliente: ['CUIT', 'FCICNV', 'CCN'],
};